import { useMutation, useQueryClient } from '@tanstack/react-query'

import { QUERY_KEYS } from '../../../QueryKeys'
import { tasksService } from '../../tasksService'
import { TaskTemplateFormPayload } from '../../types'

export const useCreateTemplate = (siteLocation?: string) => {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: (data: TaskTemplateFormPayload) => {
            return tasksService.createTaskTemplate({ ...data, siteLocation })
        },
        onSuccess: () =>
            Promise.all([
                qc.invalidateQueries({ queryKey: [QUERY_KEYS.tasks.templates.TASK_TEMPLATES] }),
                qc.invalidateQueries({
                    queryKey: [QUERY_KEYS.tasks.templates.TASK_TEMPLATES_ASSIGNEES],
                }),
            ]),
    })
}
